/*
 * *
 *   ~  * Copyright (c) by INFODATA-GROUP. All rights reserved.
 *   ~  * No part of this publication may be reproduced, distributed,
 *   ~  * or transmitted in any form or by any means, including photocopying, recording,
 *   ~  * or other electronic or mechanical methods, without the prior written permission of the publisher,
 *   ~  * except in the case of brief quotations embodied in critical
 *   ~  * reviews and certain other noncommercial uses permitted by copyright law.
 *   ~  * AUTHOR : bs
 *   ~  * DATE : 29/04/2025 17:11
 *
 */

import { CommonModule } from '@angular/common';
import {
  Component,
  effect,
  EventEmitter,
  input,
  Output,
  signal,
} from '@angular/core';
import {
  ActionEvent,
  DropdownAction,
  StandardAction,
  SwitchAction,
} from '@infodata-group/inf-commons';
import { TouchActionComponent } from './touch-action/touch-action.component';
import { TouchSwitchActionComponent } from './touch-switch-action/touch-switch-action.component';
import { TouchDropdownActionComponent } from './touch-dropdown-action/touch-dropdown-action.component';

@Component({
  selector: 'infl-drawing-header-action',
  standalone: true,
  imports: [
    CommonModule,
    TouchActionComponent,
    TouchSwitchActionComponent,
    TouchDropdownActionComponent,
  ],
  templateUrl: './drawing-header-action.component.html',
  styleUrl: './drawing-header-action.component.scss',
})
export class DrawingHeaderActionComponent {
  public action = input.required<StandardAction>();

  @Output() actionClick = new EventEmitter<ActionEvent>();
  @Output() longPress = new EventEmitter<ActionEvent>();

  public standardAction = signal<StandardAction>(null);
  public switchAction = signal<SwitchAction<any>>(null);
  public dropdownAction = signal<DropdownAction>(null);

  constructor() {
    effect(() => {
      const action = this.action();
      if (action instanceof StandardAction) {
        this.standardAction.set(action);
      }
      if (action instanceof SwitchAction) {
        this.switchAction.set(action);
      }
      if (action instanceof DropdownAction) {
        this.dropdownAction.set(action);
      }
    });
  }
}
